import { Component, Input } from '@angular/core';
import { OpsStatus } from '@models/system-status';

@Component({
    selector: 'app-ops-status',
    templateUrl: './ops-status.component.html',
    styleUrls: ['./ops-status.component.scss'],
    standalone: false
})
export class OpsStatusComponent {
  @Input() opsArray: OpsStatus[]
  @Input() isReceivingData: boolean;

}
